import { css } from 'styled-components';
import { breakpoints } from 'modules/v2/foundation/breakpoints';
import { themeGet } from 'modules/v2/foundation/theme';
const stickyStyles = css `
  z-index: 1;
  background-color: ${themeGet('colors.background.50')};
  position: sticky;

  ${({ $stickyColumn }) => $stickyColumn === 'left' &&
    css `
      left: 0;
    `};
  ${({ $stickyColumn }) => $stickyColumn === 'right' &&
    css `
      right: 0;
    `};
`;
const hiddenStyles = css `
  display: none;
`;
export const tableCellStyles = css `
  margin: 0;
  text-align: left;
  vertical-align: middle;
  min-width: min-content;
  padding: 0 var(--table-cell-padding);

  ${breakpoints.xs} {
    padding: 0 ${themeGet('spacing.sm')};
  }

  ${({ $hide }) => $hide && hiddenStyles};
  ${({ $stickyColumn }) => $stickyColumn !== undefined && stickyStyles};
`;
